__turbopack_context__.v({
  "benefitsBullet": "RegisterModal-module__ebD5tW__benefitsBullet",
  "benefitsSubitle": "RegisterModal-module__ebD5tW__benefitsSubitle",
  "benefitsTitle": "RegisterModal-module__ebD5tW__benefitsTitle",
  "checkboxWrapper": "RegisterModal-module__ebD5tW__checkboxWrapper",
  "consentNotice": "RegisterModal-module__ebD5tW__consentNotice",
  "iconCheck": "RegisterModal-module__ebD5tW__iconCheck",
  "imageWrapper": "RegisterModal-module__ebD5tW__imageWrapper",
  "linkCheckbox": "RegisterModal-module__ebD5tW__linkCheckbox",
  "styledInputs": "RegisterModal-module__ebD5tW__styledInputs",
  "textWrapper": "RegisterModal-module__ebD5tW__textWrapper",
});
